import { Injectable, computed, signal } from '@angular/core';
import { currentLanguage, supportedLanguage, changeLanguage, slText, LANGUAGE_OPTIONS } from '@screenleads/i18n';
// Adapter for the unpublished progressive-capture work. Language/catalog ownership stays shared.
const es = {
  "language": "Idioma",
  "title": "Continúa con tu promoción",
  "intro": "Crea tu cuenta con tu email. Podrás completar tu perfil más adelante.",
  "email": "Email",
  "password": "Contraseña",
  "passwordHelp": "Al menos 8 caracteres",
  "show": "Mostrar",
  "hide": "Ocultar",
  "optionalDetails": "Añadir datos opcionales",
  "name": "Cómo te llamas (opcional)",
  "phone": "Teléfono (opcional)",
  "phoneHelp": "Incluye el prefijo internacional, sin espacios.",
  "terms": "Acepto los términos y condiciones",
  "emailError": "Introduce un email válido.",
  "requiredTerms": "Acepta los términos para crear tu cuenta.",
  "submit": "Crear cuenta y continuar",
  "busy": "Creando tu cuenta…",
  "already": "¿Ya tienes cuenta?",
  "login": "Inicia sesión",
  "registerError": "No se pudo crear tu cuenta. Revisa los datos e inténtalo de nuevo.",
  "marketingTitle": "Comunicaciones comerciales (opcional)",
  "marketingIntro": "Puedes darte de baja cuando quieras. Tu cuenta y tus cupones no dependen de aceptar publicidad.",
  "marketingProfile": "Elige cómo quieres recibir ofertas de",
  "marketingProfileEnd": "Puedes cambiarlo o darte de baja desde tu perfil.",
  "wantOffers": "Quiero recibir ofertas y novedades de",
  "by": " por ",
  "and": " y ",
  "company": "esta empresa",
  "noContact": "Añade tu email o un teléfono con prefijo internacional para elegir los canales disponibles.",
  "disabled": "Esta empresa tiene desactivadas las comunicaciones comerciales.",
  "addPhone": "Para incluir SMS o WhatsApp, añade un teléfono con prefijo internacional y marca la casilla.",
  "individual": "Acepto recibir ofertas y comunicaciones comerciales por",
  "channelOff": "Esta empresa tiene el canal desactivado.",
  "emailNeeded": "Añade tu email para elegir este canal.",
  "phoneNeeded": "Añade un teléfono con prefijo internacional para elegir este canal.",
  "reconfirm": "Necesitamos que confirmes de nuevo esta preferencia.",
  "privacy": "Política de privacidad de la empresa",
  "loading": "Cargando preferencias…",
  "loadError": "No se pudieron cargar las preferencias. Puedes reintentar; no se concede ninguna autorización automáticamente.",
  "retry": "Reintentar",
  "savePreferences": "Guardar preferencias",
  "saving": "Guardando…",
  "changedPolicy": "La política cambió. Recarga las preferencias antes de aceptar.",
  "saveError": "No se guardaron las preferencias. Revisa los datos e inténtalo de nuevo.",
  "completionTitle": "Haz tuyo este perfil",
  "completionText": "Añade solo los datos que quieras compartir. Tu cupón seguirá disponible.",
  "complete": "Completar mi perfil",
  "later": "Ahora no",
  "home": "Inicio",
  "coupons": "Cupones",
  "saved": "Guardados",
  "scan": "Escanear",
  "profile": "Perfil",
  "profileData": "Mis datos",
  "surname": "Apellidos (opcional)",
  "birthday": "Cumpleaños (opcional)",
  "birthdayHelp": "Compartir tu cumpleaños no autoriza por sí solo los envíos comerciales.",
  "cancel": "Cancelar",
  "saveChanges": "Guardar cambios",
  "missingName": "Nombre",
  "missingPhone": "Teléfono",
  "missingBirthday": "Cumpleaños",
  "couponAction": "Obtener cupón",
  "raffleAction": "Participar en el sorteo",
  "welcome": "Bienvenido",
  "loginIntro": "Entra para consultar tus promociones y cupones",
  "authContinue": "Inicia sesión para continuar con esta acción.",
  "optionalNotice": "El permiso comercial es opcional.",
  "step": "Cuenta → promoción → perfil opcional"
} as const;
type CaptureCopy = Record<keyof typeof es, string>;
@Injectable({ providedIn: 'root' })
export class CaptureLanguageService {
 readonly language = signal(currentLanguage());
 readonly copy = computed(() => Object.fromEntries(Object.entries(es).map(([key, value]) =>
  [key, slText(value, undefined, this.language())])) as CaptureCopy);
 readonly options = LANGUAGE_OPTIONS;
 set(raw: string): void { const language = supportedLanguage(raw); if (language && language !== this.language()) changeLanguage(language); }
}
